const validate = value => {
  var regEx = new RegExp('^[a-zA-Z -]+$')
  if (!regEx.test(value)) {
    return false
  }
  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'Please only encode letters'
  }
}
